import * as React from "react";

export function Email(props) {
  return (
    <svg
      width={64}
      height={45}
      viewBox="0 0 64 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.372.6A4.372 4.372 0 000 4.974v35.421a4.372 4.372 0 004.372 4.372h55.256A4.372 4.372 0 0064 40.394V4.973A4.372 4.372 0 0059.628.6H4.372zm.961 8.001V39.86h53.334V8.6L32 30.907 5.333 8.6zm49.102-3.093H9.564L32 24.275 54.435 5.508z"
        fill="#FAFAFA"
      />
    </svg>
  );
}
